import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { PageLoader } from '~/routes/public/pages';
import { AdminSessionProvider, ImpersonationProvider, useAdminSession } from './contexts';
import Administrators from './administrators';
import Ai from './ai';
import Dashboards from './dashboards';
import DemoWorkspaces from './demo-workspaces';
import Emails from './emails';
import Entities from './entities';
import Login from './login/Login';
import Members from './members';
import Notifications from './notifications';
import ProductUpdates from './product-updates';
import FeedbackItems from './feedback-items';
import Reports from './reports';
import Traces from './traces';
import Workspaces from './workspaces/Workspaces';
import WorkspaceRequests from './workspace-requests';
import Xero from './xero';

function Admin() {
  return (
    <AdminSessionProvider>
      <ImpersonationProvider>
        <AdminRoutes />
      </ImpersonationProvider>
    </AdminSessionProvider>
  );
}

function AdminRoutes() {
  const { isReady, isLoggedIn, can } = useAdminSession();
  const { path } = useRouteMatch();

  if (!isReady) return <PageLoader />;

  if (!isLoggedIn)
    return (
      <>
        <Route exact path={`${path}/login`}>
          <Login />
        </Route>
        <Redirect to={`${path}/login`} />
      </>
    );

  return (
    <Switch>
      {can('ai') && (
        <Route path={`${path}/ai`}>
          <Ai />
        </Route>
      )}
      {can('admins') && (
        <Route path={`${path}/administrators`}>
          <Administrators />
        </Route>
      )}
      {can('traces') && (
        <Route path={`${path}/traces`}>
          <Traces />
        </Route>
      )}
      {can('traces') && (
        <Route path={`${path}/entities`}>
          <Entities />
        </Route>
      )}
      {can('traces') && (
        <Route path={`${path}/notifications`}>
          <Notifications />
        </Route>
      )}
      <Route path={`${path}/dashboards`}>
        <Dashboards />
      </Route>
      <Route path={`${path}/demo-workspaces`}>
        <DemoWorkspaces />
      </Route>
      <Route path={`${path}/reports`}>
        <Reports />
      </Route>
      <Route path={`${path}/workspace-requests`}>
        <WorkspaceRequests />
      </Route>
      <Route path={`${path}/workspaces`}>
        <Workspaces />
      </Route>
      <Route path={`${path}/members`}>
        <Members />
      </Route>
      <Route path={`${path}/emails`}>
        <Emails />
      </Route>
      <Route path={`${path}/whats-new`}>
        <ProductUpdates />
      </Route>
      <Route path={`${path}/feedback-items`}>
        <FeedbackItems />
      </Route>
      <Route path={`${path}/xero`}>
        <Xero />
      </Route>
      <Redirect path={path} to={`${path}/dashboards`} />
    </Switch>
  );
}

export default Admin;
